import { useState } from "react";
import { PJInputCard } from "./components/PJInputCard";
import { PJResponse } from "./components/PJResponse";
import type { PJResultsType } from "./calculadora-pj";

export default function CalculadoraPJ() {
  const [results, setResults] = useState<PJResultsType | null>(null);

  return (
    <div className="max-w-4xl mx-auto p-4">
      <PJInputCard setResults={setResults} />
      {results && <PJResponse results={results} />}
    </div>
  );
}